<template>
  <v-container class="py-5">
    <v-card class="py-5" elevation="1">
      <v-card-title class="pa-8">
        <v-layout row wrap>
          <v-row>
            <h3 class="pl-4">
              <v-icon class="mr-2" color="primary" size="32">mdi-table-account</v-icon>
              Ratio of Selected Health professionals to population
            </h3>
          </v-row>
          <v-spacer></v-spacer>
          <v-row class="pr-4 pt-2" justify="end">
            <v-btn
                class="mr-2"
                color="accent"
                @click="openBarChartDialog"
            >
              <v-icon left>mdi-chart-bar</v-icon>
              Bar chart
            </v-btn>
            <v-btn
                class="mr-2"
                color="info"
                @click="openLineChartDialog"
            >
              <v-icon left>mdi-chart-line</v-icon>
              Line chart
            </v-btn>
            <v-btn
                class="mr-2"
                color="primary"
                @click="dataExportCSV"
            >
              <v-icon left>mdi-microsoft-excel</v-icon>
              Export Report
            </v-btn>
          </v-row>
        </v-layout>
      </v-card-title>
      <v-divider class="my-2"></v-divider>
      <v-card-text>
        <v-card-text id="healthWorkersGenderDistribution">
          <v-data-table
              v-if="!loading"
              id="healthWorkersRatioTable"
              :headers="headers"
              :items="data"
              :items-per-page="5"
              class="transparent elevation-3 my-4"
              disable-pagination
              disable-sort
              hide-default-footer
              hide-default-header
          >
            <template #header="{ }">
              <thead class="v-data-table-header">
              <tr>
                <th v-for="(h,i) in headers" :key="i" :colspan="h.colspan"
                    :rowspan="h.rowspan" class="text-center parent-header td-border-style">
                  {{ h.text }}
                </th>
              </tr>
              <tr>
                <th v-for="(h1,i1) in getSubHeader(headers)" :key="i1" :colspan="h1.colspan" :rowspan="h1.rowspan"
                    class="text-center child-header td-border-style">
                  {{ h1.text }}
                </th>
              </tr>
              <tr>
                <th v-for="(h2,i1) in getSubSubHeader(headers)" :key="i1" :colspan="h2.colspan" :rowspan="h2.rowspan"
                    class="text-center child-header td-border-style">
                  {{ h2.text }}
                </th>
              </tr>
              </thead>
            </template>
            <template #item="props">
              <tr>
                <td>{{ props.item.name }}</td>
                <td>{{ props.item.population }}</td>
                <td>{{ props.item.category.prostethicorthothic.male }}</td>
                <td>{{ props.item.category.prostethicorthothic.female }}</td>
                <td>{{ props.item.category.prostethicorthothic.ratio }}</td>
                <td>{{ props.item.category.midwifery.male }}</td>
                <td>{{ props.item.category.midwifery.female }}</td>
                <td>{{ props.item.category.midwifery.ratio }}</td>
                <td>{{ props.item.category.healthextension.male }}</td>
                <td>{{ props.item.category.healthextension.female }}</td>
                <td>{{ props.item.category.healthextension.ratio }}</td>
                <td>{{ props.item.category.publichealth.male }}</td>
                <td>{{ props.item.category.publichealth.female }}</td>
                <td>{{ props.item.category.publichealth.ratio }}</td>
                <td>{{ props.item.category.othermScprofessionalspecialist.male }}</td>
                <td>{{ props.item.category.othermScprofessionalspecialist.female }}</td>
                <td>{{ props.item.category.othermScprofessionalspecialist.ratio }}</td>
                <td>{{ props.item.category.paramedicsprofessionalsemergencymedicaltechnician.male }}</td>
                <td>{{ props.item.category.paramedicsprofessionalsemergencymedicaltechnician.female }}</td>
                <td>{{ props.item.category.paramedicsprofessionalsemergencymedicaltechnician.ratio }}</td>
                <td>{{ props.item.category.emergencyandcritical.male }}</td>
                <td>{{ props.item.category.emergencyandcritical.female }}</td>
                <td>{{ props.item.category.emergencyandcritical.ratio }}</td>
                <td>{{ props.item.category.radiology.male }}</td>
                <td>{{ props.item.category.radiology.female }}</td>
                <td>{{ props.item.category.radiology.ratio }}</td>
                <td>{{ props.item.category.anesthesia.male }}</td>
                <td>{{ props.item.category.anesthesia.female }}</td>
                <td>{{ props.item.category.anesthesia.ratio }}</td>
                <td>{{ props.item.category.nursing.male }}</td>
                <td>{{ props.item.category.nursing.female }}</td>
                <td>{{ props.item.category.nursing.ratio }}</td>
                <td>{{ props.item.category.opthalmology.male }}</td>
                <td>{{ props.item.category.opthalmology.female }}</td>
                <td>{{ props.item.category.opthalmology.ratio }}</td>
                <td>{{ props.item.category.psychiatry.male }}</td>
                <td>{{ props.item.category.psychiatry.female }}</td>
                <td>{{ props.item.category.psychiatry.ratio }}</td>
                <td>{{ props.item.category.otherbscprofessionals.male }}</td>
                <td>{{ props.item.category.otherbscprofessionals.female }}</td>
                <td>{{ props.item.category.otherbscprofessionals.ratio }}</td>
                <td>{{ props.item.category.environmentaloccupationalhealth.male }}</td>
                <td>{{ props.item.category.environmentaloccupationalhealth.female }}</td>
                <td>{{ props.item.category.environmentaloccupationalhealth.ratio }}</td>
                <td>{{ props.item.category.audiometry.male }}</td>
                <td>{{ props.item.category.audiometry.female }}</td>
                <td>{{ props.item.category.audiometry.ratio }}</td>
                <td>{{ props.item.category.specialist.male }}</td>
                <td>{{ props.item.category.specialist.female }}</td>
                <td>{{ props.item.category.specialist.ratio }}</td>
                <td>{{ props.item.category.heahlthassistant.male }}</td>
                <td>{{ props.item.category.heahlthassistant.female }}</td>
                <td>{{ props.item.category.heahlthassistant.ratio }}</td>
                <td>{{ props.item.category.temporarytransitionpositions.male }}</td>
                <td>{{ props.item.category.temporarytransitionpositions.female }}</td>
                <td>{{ props.item.category.temporarytransitionpositions.ratio }}</td>
                <td>{{ props.item.category.otherprofessionals.male }}</td>
                <td>{{ props.item.category.otherprofessionals.female }}</td>
                <td>{{ props.item.category.otherprofessionals.ratio }}</td>
                <td>{{ props.item.category.publichealthprofessionalspecialist.male }}</td>
                <td>{{ props.item.category.publichealthprofessionalspecialist.female }}</td>
                <td>{{ props.item.category.publichealthprofessionalspecialist.ratio }}</td>
                <td>{{ props.item.category.radiationtherapist.male }}</td>
                <td>{{ props.item.category.radiationtherapist.female }}</td>
                <td>{{ props.item.category.radiationtherapist.ratio }}</td>
                <td>{{ props.item.category.subspecialist.male }}</td>
                <td>{{ props.item.category.subspecialist.female }}</td>
                <td>{{ props.item.category.subspecialist.ratio }}</td>
                <td>{{ props.item.category.administrativestaff812.male }}</td>
                <td>{{ props.item.category.administrativestaff812.female }}</td>
                <td>{{ props.item.category.administrativestaff812.ratio }}</td>
                <td>{{ props.item.category.administrativestaffdiplomacoc.male }}</td>
                <td>{{ props.item.category.administrativestaffdiplomacoc.female }}</td>
                <td>{{ props.item.category.administrativestaffdiplomacoc.ratio }}</td>
                <td>{{ props.item.category.administrativestaffdegreemastersphd.male }}</td>
                <td>{{ props.item.category.administrativestaffdegreemastersphd.female }}</td>
                <td>{{ props.item.category.administrativestaffdegreemastersphd.ratio }}</td>
                <td>{{ props.item.category.medicaldoctor.male }}</td>
                <td>{{ props.item.category.medicaldoctor.female }}</td>
                <td>{{ props.item.category.medicaldoctor.ratio }}</td>
                <td>{{ props.item.category.dentalscience.male }}</td>
                <td>{{ props.item.category.dentalscience.female }}</td>
                <td>{{ props.item.category.dentalscience.ratio }}</td>
                <td>{{ props.item.category.pharmacy.male }}</td>
                <td>{{ props.item.category.pharmacy.female }}</td>
                <td>{{ props.item.category.pharmacy.ratio }}</td>
                <td>{{ props.item.category.medicalpharmacy.male }}</td>
                <td>{{ props.item.category.medicalpharmacy.female }}</td>
                <td>{{ props.item.category.medicalpharmacy.ratio }}</td>
                <td>{{ props.item.category.forensicmedicine.male }}</td>
                <td>{{ props.item.category.forensicmedicine.female }}</td>
                <td>{{ props.item.category.forensicmedicine.ratio }}</td>
                <td>{{ props.item.category.physiotheraphy.male }}</td>
                <td>{{ props.item.category.physiotheraphy.female }}</td>
                <td>{{ props.item.category.physiotheraphy.ratio }}</td>
                <td>{{ props.item.category.biomedicaltechnology.male }}</td>
                <td>{{ props.item.category.biomedicaltechnology.female }}</td>
                <td>{{ props.item.category.biomedicaltechnology.ratio }}</td>
                <td>{{ props.item.category.medicallaboratory.male }}</td>
                <td>{{ props.item.category.medicallaboratory.female }}</td>
                <td>{{ props.item.category.medicallaboratory.ratio }}</td>
                <td>{{ props.item.category.healthinformationtechnology.male }}</td>
                <td>{{ props.item.category.healthinformationtechnology.female }}</td>
                <td>{{ props.item.category.healthinformationtechnology.ratio }}</td>
                <td>{{ props.item.category.totalSelected.male }}</td>
                <td>{{ props.item.category.totalSelected.female }}</td>
                <td>{{ props.item.category.totalSelected.ratio }}</td>
              </tr>
            </template>
            <template slot="body.append" v-if="this.userFacilityId === 'federal-ministry-of-health'">
              <tr class="pink--text">
                <th>National Level</th>
                <th>{{ sumField('population') }}</th>
                <th>{{ sumField('category.prostethicorthothic.male') }}</th>
                <th>{{ sumField('category.prostethicorthothic.female') }}</th>
                <th>
                  {{
                    (sumField('category.prostethicorthothic.male') + sumField('category.prostethicorthothic.female')) > 0 ? (sumField('population') / (sumField('category.prostethicorthothic.male') + sumField('category.prostethicorthothic.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.midwifery.male') }}</th>
                <th>{{ sumField('category.midwifery.female') }}</th>
                <th>
                  {{
                    (sumField('category.midwifery.male') + sumField('category.midwifery.female')) > 0 ? (sumField('population') / (sumField('category.midwifery.male') + sumField('category.midwifery.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.healthextension.male') }}</th>
                <th>{{ sumField('category.healthextension.female') }}</th>
                <th>
                  {{
                    (sumField('category.healthextension.male') + sumField('category.healthextension.female')) > 0 ? (sumField('population') / (sumField('category.healthextension.male') + sumField('category.healthextension.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.publichealth.male') }}</th>
                <th>{{ sumField('category.publichealth.female') }}</th>
                <th>
                  {{
                    (sumField('category.publichealth.male') + sumField('category.publichealth.female')) > 0 ? (sumField('population') / (sumField('category.publichealth.male') + sumField('category.publichealth.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.othermScprofessionalspecialist.male') }}</th>
                <th>{{ sumField('category.othermScprofessionalspecialist.female') }}</th>
                <th>
                  {{
                    (sumField('category.othermScprofessionalspecialist.male') + sumField('category.othermScprofessionalspecialist.female')) > 0 ? (sumField('population') / (sumField('category.othermScprofessionalspecialist.male') + sumField('category.othermScprofessionalspecialist.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.paramedicsprofessionalsemergencymedicaltechnician.male') }}</th>
                <th>{{ sumField('category.paramedicsprofessionalsemergencymedicaltechnician.female') }}</th>
                <th>
                  {{
                    (sumField('category.paramedicsprofessionalsemergencymedicaltechnician.male') + sumField('category.paramedicsprofessionalsemergencymedicaltechnician.female')) > 0 ? (sumField('population') / (sumField('category.paramedicsprofessionalsemergencymedicaltechnician.male') + sumField('category.paramedicsprofessionalsemergencymedicaltechnician.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.emergencyandcritical.male') }}</th>
                <th>{{ sumField('category.emergencyandcritical.female') }}</th>
                <th>
                  {{
                    (sumField('category.emergencyandcritical.male') + sumField('category.emergencyandcritical.female')) > 0 ? (sumField('population') / (sumField('category.emergencyandcritical.male') + sumField('category.emergencyandcritical.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.radiology.male') }}</th>
                <th>{{ sumField('category.radiology.female') }}</th>
                <th>
                  {{
                    (sumField('category.radiology.male') + sumField('category.radiology.female')) > 0 ? (sumField('population') / (sumField('category.radiology.male') + sumField('category.radiology.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.anesthesia.male') }}</th>
                <th>{{ sumField('category.anesthesia.female') }}</th>
                <th>
                  {{
                    (sumField('category.anesthesia.male') + sumField('category.anesthesia.female')) > 0 ? (sumField('population') / (sumField('category.anesthesia.male') + sumField('category.anesthesia.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.nursing.male') }}</th>
                <th>{{ sumField('category.nursing.female') }}</th>
                <th>
                  {{
                    (sumField('category.nursing.male') + sumField('category.nursing.female')) > 0 ? (sumField('population') / (sumField('category.nursing.male') + sumField('category.nursing.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.opthalmology.male') }}</th>
                <th>{{ sumField('category.opthalmology.female') }}</th>
                <th>
                  {{
                    (sumField('category.opthalmology.male') + sumField('category.opthalmology.female')) > 0 ? (sumField('population') / (sumField('category.opthalmology.male') + sumField('category.opthalmology.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.psychiatry.male') }}</th>
                <th>{{ sumField('category.psychiatry.female') }}</th>
                <th>
                  {{
                    (sumField('category.psychiatry.male') + sumField('category.psychiatry.female')) > 0 ? (sumField('population') / (sumField('category.psychiatry.male') + sumField('category.psychiatry.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.otherbscprofessionals.male') }}</th>
                <th>{{ sumField('category.otherbscprofessionals.female') }}</th>
                <th>
                  {{
                    (sumField('category.otherbscprofessionals.male') + sumField('category.otherbscprofessionals.female')) > 0 ? (sumField('population') / (sumField('category.otherbscprofessionals.male') + sumField('category.otherbscprofessionals.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.environmentaloccupationalhealth.male') }}</th>
                <th>{{ sumField('category.environmentaloccupationalhealth.female') }}</th>
                <th>
                  {{
                    (sumField('category.environmentaloccupationalhealth.male') + sumField('category.environmentaloccupationalhealth.female')) > 0 ? (sumField('population') / (sumField('category.environmentaloccupationalhealth.male') + sumField('category.environmentaloccupationalhealth.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.audiometry.male') }}</th>
                <th>{{ sumField('category.audiometry.female') }}</th>
                <th>
                  {{
                    (sumField('category.audiometry.male') + sumField('category.audiometry.female')) > 0 ? (sumField('population') / (sumField('category.audiometry.male') + sumField('category.audiometry.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.specialist.male') }}</th>
                <th>{{ sumField('category.specialist.female') }}</th>
                <th>
                  {{
                    (sumField('category.specialist.male') + sumField('category.specialist.female')) > 0 ? (sumField('population') / (sumField('category.specialist.male') + sumField('category.specialist.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.heahlthassistant.male') }}</th>
                <th>{{ sumField('category.heahlthassistant.female') }}</th>
                <th>
                  {{
                    (sumField('category.heahlthassistant.male') + sumField('category.heahlthassistant.female')) > 0 ? (sumField('population') / (sumField('category.heahlthassistant.male') + sumField('category.heahlthassistant.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.temporarytransitionpositions.male') }}</th>
                <th>{{ sumField('category.temporarytransitionpositions.female') }}</th>
                <th>
                  {{
                    (sumField('category.temporarytransitionpositions.male') + sumField('category.temporarytransitionpositions.female')) > 0 ? (sumField('population') / (sumField('category.temporarytransitionpositions.male') + sumField('category.temporarytransitionpositions.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.otherprofessionals.male') }}</th>
                <th>{{ sumField('category.otherprofessionals.female') }}</th>
                <th>
                  {{
                    (sumField('category.otherprofessionals.male') + sumField('category.otherprofessionals.female')) > 0 ? (sumField('population') / (sumField('category.otherprofessionals.male') + sumField('category.otherprofessionals.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.publichealthprofessionalspecialist.male') }}</th>
                <th>{{ sumField('category.publichealthprofessionalspecialist.female') }}</th>
                <th>
                  {{
                    (sumField('category.publichealthprofessionalspecialist.male') + sumField('category.publichealthprofessionalspecialist.female')) > 0 ? (sumField('population') / (sumField('category.publichealthprofessionalspecialist.male') + sumField('category.publichealthprofessionalspecialist.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.radiationtherapist.male') }}</th>
                <th>{{ sumField('category.radiationtherapist.female') }}</th>
                <th>
                  {{
                    (sumField('category.radiationtherapist.male') + sumField('category.radiationtherapist.female')) > 0 ? (sumField('population') / (sumField('category.radiationtherapist.male') + sumField('category.radiationtherapist.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.subspecialist.male') }}</th>
                <th>{{ sumField('category.subspecialist.female') }}</th>
                <th>
                  {{
                    (sumField('category.subspecialist.male') + sumField('category.subspecialist.female')) > 0 ? (sumField('population') / (sumField('category.subspecialist.male') + sumField('category.subspecialist.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.administrativestaff812.male') }}</th>
                <th>{{ sumField('category.administrativestaff812.female') }}</th>
                <th>
                  {{
                    (sumField('category.administrativestaff812.male') + sumField('category.administrativestaff812.female')) > 0 ? (sumField('population') / (sumField('category.administrativestaff812.male') + sumField('category.administrativestaff812.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.administrativestaffdiplomacoc.male') }}</th>
                <th>{{ sumField('category.administrativestaffdiplomacoc.female') }}</th>
                <th>
                  {{
                    (sumField('category.administrativestaffdiplomacoc.male') + sumField('category.administrativestaffdiplomacoc.female')) > 0 ? (sumField('population') / (sumField('category.administrativestaffdiplomacoc.male') + sumField('category.administrativestaffdiplomacoc.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.administrativestaffdegreemastersphd.male') }}</th>
                <th>{{ sumField('category.administrativestaffdegreemastersphd.female') }}</th>
                <th>
                  {{
                    (sumField('category.administrativestaffdegreemastersphd.male') + sumField('category.administrativestaffdegreemastersphd.female')) > 0 ? (sumField('population') / (sumField('category.administrativestaffdegreemastersphd.male') + sumField('category.administrativestaffdegreemastersphd.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.medicaldoctor.male') }}</th>
                <th>{{ sumField('category.medicaldoctor.female') }}</th>
                <th>
                  {{
                    (sumField('category.medicaldoctor.male') + sumField('category.medicaldoctor.female')) > 0 ? (sumField('population') / (sumField('category.medicaldoctor.male') + sumField('category.medicaldoctor.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.dentalscience.male') }}</th>
                <th>{{ sumField('category.dentalscience.female') }}</th>
                <th>
                  {{
                    (sumField('category.dentalscience.male') + sumField('category.dentalscience.female')) > 0 ? (sumField('population') / (sumField('category.dentalscience.male') + sumField('category.dentalscience.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.pharmacy.male') }}</th>
                <th>{{ sumField('category.pharmacy.female') }}</th>
                <th>
                  {{
                    (sumField('category.pharmacy.male') + sumField('category.pharmacy.female')) > 0 ? (sumField('population') / (sumField('category.pharmacy.male') + sumField('category.pharmacy.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.medicalpharmacy.male') }}</th>
                <th>{{ sumField('category.medicalpharmacy.female') }}</th>
                <th>
                  {{
                    (sumField('category.medicalpharmacy.male') + sumField('category.medicalpharmacy.female')) > 0 ? (sumField('population') / (sumField('category.medicalpharmacy.male') + sumField('category.medicalpharmacy.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.forensicmedicine.male') }}</th>
                <th>{{ sumField('category.forensicmedicine.female') }}</th>
                <th>
                  {{
                    (sumField('category.forensicmedicine.male') + sumField('category.forensicmedicine.female')) > 0 ? (sumField('population') / (sumField('category.forensicmedicine.male') + sumField('category.forensicmedicine.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.physiotheraphy.male') }}</th>
                <th>{{ sumField('category.physiotheraphy.female') }}</th>
                <th>
                  {{
                    (sumField('category.physiotheraphy.male') + sumField('category.physiotheraphy.female')) > 0 ? (sumField('population') / (sumField('category.physiotheraphy.male') + sumField('category.physiotheraphy.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.biomedicaltechnology.male') }}</th>
                <th>{{ sumField('category.biomedicaltechnology.female') }}</th>
                <th>
                  {{
                    (sumField('category.biomedicaltechnology.male') + sumField('category.biomedicaltechnology.female')) > 0 ? (sumField('population') / (sumField('category.biomedicaltechnology.male') + sumField('category.biomedicaltechnology.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.medicallaboratory.male') }}</th>
                <th>{{ sumField('category.medicallaboratory.female') }}</th>
                <th>
                  {{
                    (sumField('category.medicallaboratory.male') + sumField('category.medicallaboratory.female')) > 0 ? (sumField('population') / (sumField('category.medicallaboratory.male') + sumField('category.medicallaboratory.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.healthinformationtechnology.male') }}</th>
                <th>{{ sumField('category.healthinformationtechnology.female') }}</th>
                <th>
                  {{
                    (sumField('category.healthinformationtechnology.male') + sumField('category.healthinformationtechnology.female')) > 0 ? (sumField('population') / (sumField('category.healthinformationtechnology.male') + sumField('category.healthinformationtechnology.female'))).toFixed(2) : '-'
                  }}
                </th>
                <th>{{ sumField('category.totalSelected.male') }}</th>
                <th>{{ sumField('category.totalSelected.female') }}</th>
                <th>
                  {{
                    (sumField('category.totalSelected.male') + sumField('category.totalSelected.female')) > 0 ? (sumField('population') / (sumField('category.totalSelected.male') + sumField('category.totalSelected.female'))).toFixed(2) : '-'
                  }}
                </th>
                "
              </tr>
            </template>
          </v-data-table>
          <h1 v-else>
            <v-col
                class="h5 text-center"
                cols="12"
            >
              Loading The Report ...
            </v-col>
            <v-row
                align-content="center"
                class="fill-height"
                justify="center"
            >
              <v-col class="my-12" cols="6">
                <v-progress-linear
                    color="primary"
                    height="6"
                    indeterminate
                    rounded
                ></v-progress-linear>
              </v-col>
            </v-row>
          </h1>
        </v-card-text>
      </v-card-text>
      <v-card-text>
        <div class="text-center">
          <v-dialog
              v-model="barChartDialog"
              width="80%"
          >
            <v-card>
              <v-card-title class="text-h6 justify-center grey lighten-2">
                <v-spacer></v-spacer>
                <v-icon class="pr-2" color="green darken-2">
                  mdi-chart-bar
                </v-icon>
                Professional Category to population ratio by Region
                <v-spacer></v-spacer>
                <v-btn
                    color="red darken-2"
                    outlined
                    small
                    @click="close()"
                >
                  <v-icon color="red" left>
                    mdi-close-circle-outline
                  </v-icon>
                  Close
                </v-btn>
              </v-card-title>
              <v-card-text class=" pt-0">
                <v-container>
                  <v-row class="pb-6" justify="end">
                    <v-col
                        class="d-flex"
                        cols="12"
                        sm="4"
                    >
                      <v-select
                          v-model="selectedProfession"
                          :items="professionCategory"
                          dense
                          item-text="display"
                          label="Select Profession Category"
                          outlined
                          return-object
                          single-line
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>
                      <apexchart
                          ref="chart"
                          :options="barChartOptions"
                          :series="barChartSeries"
                          height="700"
                          type="bar"
                      ></apexchart>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <v-dialog
              v-model="lineChartDialog"
              width="80%"
          >
            <v-card>
              <v-card-title class="text-h6 justify-center grey lighten-2">
                <v-spacer></v-spacer>
                <v-icon class="pr-2" color="green darken-2">
                  mdi-chart-line
                </v-icon>
                Professional Category to population ratio overtime
                <v-spacer></v-spacer>
                <v-btn
                    color="red darken-2"
                    outlined
                    small
                    @click="close()"
                >
                  <v-icon color="red" left>
                    mdi-close-circle-outline
                  </v-icon>
                  Close
                </v-btn>
              </v-card-title>
              <v-card-text class=" pt-0">
                <v-container>
                  <v-row class="pb-6" justify="end">
                    <v-col
                        class="d-flex"
                        cols="12"
                        sm="4"
                    >
                      <v-select
                          v-model="selectedProfession"
                          :items="professionCategory"
                          dense
                          item-text="display"
                          label="Select Profession Category"
                          outlined
                          return-object
                          single-line
                      ></v-select>
                    </v-col>
                  </v-row>
                  <v-row no-gutters>
                    <v-col>
                      <apexchart :options="lineChartOptions" :series="lineChartSeries" height="700"
                                 type="line"></apexchart>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
        </div>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import XLSX from "xlsx";
import '../../plugins/chart'

export default {
  methods: {
    getSubHeader(headers) {
      let result = [];
      headers
          .filter((i) => i.children)
          .forEach((v) => {
            result = result.concat(v.children);
          });
      return result;
    },
    getSubSubHeader(headers) {
      let result = [];
      headers
          .filter((i) => i.children)
          .forEach((v) => {
            if (v.children) {
              let a = v.children;
              a.filter((i) => i.children).forEach((b) => {
                result = result.concat(b.children);
              });
            }
          });
      return result;
    },
    dataExportCSV() {
      let tbl = document.getElementById("healthWorkersRatioTable");
      const wb = XLSX.utils.table_to_book(tbl);
      XLSX.writeFile(wb, " Ratio_of_Selected_Health_professionals_to_population.xlsx");
    },
    sumField(key) {
      let keys = key.split(".");
      if (keys.length === 1) {
        return this.data.reduce((a, b) => a + (Number(b[keys[0]]) || 0), 0);
      } else if (keys.length === 2) {
        return this.data.reduce((a, b) => a + (Number(b[keys[0]][keys[1]]) || 0), 0);
      } else if (keys.length === 3) {
        return this.data.reduce((a, b) => a + (Number(b[keys[0]][keys[1]][keys[2]]) || 0), 0);
      }
    },
    close() {
      this.barChartDialog = false;
      this.lineChartDialog = false;
    },
    openBarChartDialog() {
      this.barChartDialog = true;
      this.buildBarChartWithData()
    },
    openLineChartDialog() {
      this.lineChartDialog = true;
      this.buildLineChartWithData()
    },
    buildLineChartWithData() {
      let series = [{
        name: this.selectedProfession.display,
        data: [10, 0, 35, 51, 49, 62, 69, 91, 148]
      }]
      this._buildLineChartGraphic(series);
    },
    buildBarChartWithData() {
      let professionId = this.selectedProfession.code.replace(/-/g, "")
      let finalData = this.data.map((x) =>
          isNaN(Number(x.category[professionId]?.ratio))
              ? 0
              : Number(x.category[professionId]?.ratio)
      )
      finalData.push((this.sumField(`category.${professionId}.male`) + this.sumField(`category.${professionId}.female`)) > 0 ? (this.sumField('population') / (this.sumField(`category.${professionId}.male`) + this.sumField(`category.${professionId}.female`))).toFixed(2) : 0)
      let series = [
        {
          name: `${this.selectedProfession.display} To population Ratio By Region`,
          data: finalData,
          groupColor: '#33b2df'
        }
      ];
      let categories = this.data.map(x => x.name.replace("Regional Health Bureau", "RHB").replace("South West Ethiopia Peoples", "SWEP"));
      categories.push("National Level")
      this._buildBarChartGraphic(series, categories);
    },
    _buildBarChartGraphic(series, categories) {
      this.barChartSeries = series;
      this.barChartOptions = {
        chart: {
          type: "bar",
          height: 700,
          stacked: true,
          events: {
            mounted: (chartContext, config) => {
              setTimeout(() => {
                this.addAnnotations(config, categories, this);
              });
            },
            updated: (chartContext, config) => {
              setTimeout(() => {
                this.addAnnotations(config, categories, this);
              });
            }
          }
        },
        xaxis: {
          labels: {
            rotate: -45
          },
          categories: categories
        },
        yaxis: {
          labels: {
            rotate: -45
          },
        },
        title: {
          text: `${this.selectedProfession.display} To population Ratio By Region`,
          align: 'center',
          style: {
            fontSize: '14px',
            fontWeight: 'bold',
            fontFamily: undefined,
            color: '#263238'
          },
        },
      };
      const colors = series.map((x) => x.groupColor);
      if (colors.length > 0) {
        this.barChartOptions.colors = colors;
      }
    },
    _buildLineChartGraphic(series) {
      this.lineChartSeries = series;
      this.lineChartOptions = {
        chart: {
          height: 700,
          type: 'line',
          zoom: {
            enabled: false
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: `Trends of ${this.selectedProfession.display} to population ratio in Ethiopia from 2014 to 2022`,
          align: 'center'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          },
        },
        xaxis: {
          categories: ['2014', '2015', '2016', '2017', '2018', '2019', '2020', '2021', '2022'],
        }
      }
    },
  },
  data() {
    return {
      loading: false,
      barChartDialog: false,
      barChartOptions: {
        chart: {
          type: "bar",
        },
        grid: {
          row: {
            colors: []
          }
        },
      },
      barChartSeries: [],
      lineChartSeries: [],
      lineChartOptions: {
        chart: {
          type: "line",
        },
      },
      lineChartDialog: false,
      headers: [
        {
          "text": "Region",
          "align": "center",
          "sortable": false,
          "colspan": "1",
          "rowspan": "3",
          "value": "name"
        },
        {
          "text": "Estimated Population",
          "colspan": "1",
          "rowspan": "3",
          "value": "population"
        },
        {
          "text": "Prostethic Orthothic",
          "value": "category.prostethicorthothic",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1",
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Prostethic Orthothic : Popn",
              "colspan": "1",
              "rowspan": "2",
              "value": "category.prostethicorthothic.ratio"
            }
          ]
        },
        {
          "text": "Midwifery",
          "value": "category.midwifery",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Midwifery : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Health Extension/Family health",
          "value": "category.healthextension",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Health Extension : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Public Health",
          "value": "category.publichealth",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Public Health : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Other MSc Professional Specialist",
          "value": "category.othermScprofessionalspecialist",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Other MSc Professional Specialist : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Paramedics Professionals: Emergency Medical Technician (EMT)",
          "value": "category.paramedicsprofessionalsemergencymedicaltechnician",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Paramedics Professionals: Emergency Medical Technician (EMT) : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Emergency and Critical",
          "value": "category.emergencyandcritical",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Emergency and Critical : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Radiology",
          "value": "category.radiology",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Radiology : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Anesthesia",
          "value": "category.anesthesia",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Anesthesia : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Nursing",
          "value": "category.nursing",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Nursing : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Opthalmology",
          "value": "category.opthalmology",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Opthalmology : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Psychiatry",
          "value": "category.psychiatry",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Psychiatry : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Other BSc Professionals",
          "value": "category.otherbscprofessionals",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Other BSc Professionals : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Environmental & Occupational Health",
          "value": "category.environmentaloccupationalhealth",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Environmental & Occupational Health : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Audiometry",
          "value": "category.audiometry",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Audiometry : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Specialist",
          "value": "category.specialist",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Specialist : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Health Assistant",
          "value": "category.heahlthassistant",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Health Assistant : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Temporary Transition Positions",
          "value": "category.temporarytransitionpositions",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Temporary Transition Positions : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Other Professionals",
          "value": "category.otherprofessionals",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Other Professionals : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Public Health Professional Specialist",
          "value": "category.publichealthprofessionalspecialist",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Public Health Professional Specialist : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Radiation Therapist (RTT)",
          "value": "category.radiationtherapist",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Radiation Therapist (RTT) : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Sub-Specialist",
          "value": "category.subspecialist",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Sub-Specialist : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Administrative Staff (Non-Health Profession):From Grade 8 to 12",
          "value": "category.administrativestaff812",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Administrative Staff (Non-Health Profession):From Grade 8 to 12 : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Administrative Staff (Non-Health Profession):College Diploma/Vocational COC Certificate/10+3/",
          "value": "category.administrativestaffdiplomacoc",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Administrative Staff (Non-Health Profession):College Diploma/Vocational COC Certificate/10+3/ : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Administrative Staff (Non-Health Profession):Degree/Master/PhD",
          "value": "category.administrativestaffdegreemastersphd",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Administrative Staff (Non-Health Profession):Degree/Master/PhD : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Medical Doctor",
          "value": "category.medicaldoctor",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Medical Doctor : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Dental Science",
          "value": "category.dentalscience",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Dental Science : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Pharmacy",
          "value": "category.pharmacy",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Pharmacy : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Medical Pharmacy",
          "value": "category.medicalpharmacy",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Medical Pharmacy : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Forensic Medicine",
          "value": "category.forensicmedicine",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Forensic Medicine : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": " Physiotheraphy",
          "value": "category.physiotheraphy",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1 Physiotheraphy : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Biomedical Technology",
          "value": "category.biomedicaltechnology",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Biomedical Technology : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Medical Laboratory",
          "value": "category.medicallaboratory",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Medical Laboratory : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Health Information Technology",
          "value": "category.healthinformationtechnology",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Health Information Technology : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        },
        {
          "text": "Total Selected Health Profession",
          "value": "total",
          "colspan": "3",
          "rowspan": "1",
          "children": [
            {
              "text": "Num",
              "colspan": "2",
              "rowspan": "1",
              "children": [
                {
                  "text": "M",
                  "colspan": "1",
                  "rowspan": "1"
                },
                {
                  "text": "F",
                  "colspan": "1",
                  "rowspan": "1"
                }
              ]
            },
            {
              "text": "1Total Selected Health Profession : Popn",
              "colspan": "1",
              "rowspan": "2"
            }
          ]
        }
      ],
      data: [],
      professionCategory: [],
      regions: [],
      selectedProfession: {
        "code": "nursing",
        "display": "Nursing",
        "definition": "nursing"
      },
      userFacilityId: this.$store.state.user.facilityId
    };
  },
  watch: {
    selectedProfession: function () {
      this.buildBarChartWithData()
      this.buildLineChartWithData()
    }
  },
  async created() {
    this.loading = true
    const url = `/fhir/ValueSet/ihris-profession-category/$expand`
    fetch(url).then((response) =>
        response.json().then((data) => {
          this.professionCategory = data.expansion.contains.sort((a, b) => (a.display.trim() > b.display.trim()) ? 1 : ((b.display.trim() > a.display.trim()) ? -1 : 0))
        }))
        fetch(`/fhir/Location?&_profile=http://ihris.org/fhir/StructureDefinition/ihris-jurisdiction&type=region&_sort=name`).then((response) =>
        response.json().then(async ({entry}) => {
           entry.map(async x => {
            let id = x.resource.id
            let name = x.resource.name
            let population = x.resource?.extension?.find(
                (y) =>
                    y.url ===
                    "http://ihris.org/fhir/StructureDefinition/ihris-jurisdiction-population-size"
            )?.valueString
            let res = {}
            res.name = name;
            res.population = population
            let category = {
              prostethicorthothic: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              midwifery: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              healthextension: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              publichealth: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              othermScprofessionalspecialist: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              paramedicsprofessionalsemergencymedicaltechnician: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              emergencyandcritical: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              radiology: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              anesthesia: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              nursing: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              opthalmology: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              psychiatry: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              otherbscprofessionals: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              environmentaloccupationalhealth: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              audiometry: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              specialist: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              heahlthassistant: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              temporarytransitionpositions: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              otherprofessionals: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              publichealthprofessionalspecialist: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              radiationtherapist: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              subspecialist: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              administrativestaff812: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              administrativestaffdiplomacoc: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              administrativestaffdegreemastersphd: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              medicaldoctor: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              dentalscience: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              pharmacy: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              medicalpharmacy: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              forensicmedicine: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              physiotheraphy: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              biomedicaltechnology: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              medicallaboratory: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              healthinformationtechnology: {
                "male": 0,
                "female": 0,
                "ratio": "-"
              },
              "totalSelected": {
                "male": 0,
                "female": 0,
                "ratio": "-"
              }
            };
            let total = 0;
            let query = {
              "query": {
                "bool": {
                  "must": [
                    {
                      "script": {
                        "script": {
                          "source": `if(doc['region.keyword'].size() != 0) {if(doc['region.keyword'].value.contains('Location/${id}')){return true}}`,
                          "lang": "painless"
                        }
                      }
                    }
                  ],
                  "must_not": [],
                  "filter": []
                }
              },
              "aggs": {
                "professionCategories": {
                  "composite": {
                    "sources": [
                      {
                        "categories": {
                          "terms": {
                            "field": "employeeProfessionCategory.keyword"
                          }
                        }
                      },
                      {
                        "gender": {
                          "terms": {
                            "field": "gender.keyword"
                          }
                        }
                      }
                    ],
                    "size": 10000
                  }
                }
              },
              "reportOptions": {},
            }
            const url = `/es/jobposition/_search?filter_path=aggregations`
            let response = await fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(query)
            })
            let result = await response.json()
            let totalMale = 0;
            let totalFemale = 0;
            result.aggregations.professionCategories.buckets.map((a) => {
              let key = a.key.categories.replace(/-/g, "");
              let count = a.doc_count;
              let gender = a.key.gender;
              if (gender === "male" && category[key]?.male ) {
                category[key].male += count;
                totalMale += count;
              }
              if (gender === "female" && category[key]?.female) {
                category[key].female += count;
                totalFemale += count;
              }
              total += count;
              if(category[key]?.ratio) {
                category[key].ratio = (Number(population) / total).toFixed(2);
              }
            });
            Object.values(category).map((x) => {
              if (x.female + x.male > 0)
                x.ratio = (population / (x.male + x.female)).toFixed(2);
            });
            category.totalSelected.male = totalMale
            category.totalSelected.female = totalFemale
            if (total > 0) {
              category.totalSelected.ratio = (Number(population) / total).toFixed(2)
            }
            res.category = category
            res.total = total
            this.data.push(res)
            if (this.data.length === entry.length) {
              this.loading = false
            }
          })
        }))
  }
}
</script>
<style lang="sass">
#healthWorkersGenderDistribution
  $record-text-size: 16px

  .record-item-value
    font-size: $record-text-size
    border-bottom: thin #0c0c0c

  .record-item-unit
    font-size: $record-text-size

  .record-item-value-border
    border: thin #a1a1a1
    margin-right: 4px

  .record-item-key
    font-weight: bold
    font-size: $record-text-size

  .record-content
    border: thin #a1a1a1

  .v-data-table
    td
      padding: 12px 8px
      font-size: $record-text-size
      border-color: rgba(0, 0, 0, 0.12)
      border-style: solid
      border-left-width: 0px
      border-right-width: thin
      border-top-width: 0px
      border-bottom-width: thin
      color: black

    tr
      &:nth-of-type(even)
        background-color: #ced7e1

    th
      border-color: rgb(112, 109, 109)
      border-style: solid
      border-left-width: 0px
      border-right-width: thin
      border-top-width: 0px
      border-bottom-width: thin
      color: white
      background-color: #0d3552
      letter-spacing: 0.03em
      font-size: 14px


  .v-data-table table
    //border: thin 1px #f1f0f0
    border-radius: 5px

  .v-data-table table thead tr th
    font-weight: bold
    font-size: $record-text-size
    padding: 0px 8px

  .v-data-table table tbody tr td .v-btn
    margin-right: 0px !important

  .v-data-table .v-data-table-header__sort-badge
    font-size: 10px

  .v-data-table.theme--dark
    tr th
      color: #9b2323 !important

  .theme--light
    .v-data-table table thead tr th
      color: black

    .v-data-table table thead tr td
      color: black

</style>
